import type { KyInstance } from "ky";

export interface InquiriesOverview {
  totalInquiries: number;
  averageInquiriesPerPractitioner: number;
}

export class AnalyticsApi {
  constructor(private readonly http: KyInstance) { }

  inquiriesOverview = (): Promise<InquiriesOverview> =>
    this.http.get("admin/analytics/inquiries-overview").json<InquiriesOverview>();
}
